import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const Inquiry = () => {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [service, setService] = useState<string>("");
  const [contents, setContents] = useState<string>("");

  const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone || !address) {
      Swal.fire({
        title: "이름, 연락처, 주소를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    setLoading(true);

    await axios
      .post("/api/contact", {
        name: name,
        phone: phone,
        address: address,
        service: service,
        type: 1,
        contents: contents,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };
  return (
    <div className="relative w-full h-full bg-white px-3 xs:px-5 pt-5">
      <div className=" relative w-full h-full grid grid-cols-2 lg:grid-cols-3 gap-3">
        <div className=" relative w-full h-full">
          <label htmlFor="name" className="lg:text-xl">
            이름&nbsp;<span className="text-[var(--red-color)]">*</span>
          </label>
          <input
            type="text"
            placeholder="이름을 입력해주세요"
            value={name}
            id="name"
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className=" relative w-full h-full">
          <label htmlFor="phone" className="lg:text-xl">
            연락처&nbsp;<span className="text-[var(--red-color)]">*</span>
          </label>
          <input
            type="text"
            placeholder="연락처를 입력해주세요"
            value={phone}
            id="phone"
            onChange={(e) =>
              setPhone(
                e.target.value
                  .replace(/[^0-9.]/g, "")
                  .replace(/(\..*)\./g, "$1")
              )
            }
          />
        </div>
        <div className="col-span-2 lg:col-span-1 relative w-full h-full">
          <label htmlFor="service1" className="lg:text-xl">
            문의종류
          </label>
          <select
            name="service1"
            id="service1"
            onChange={(e) => setService(e.target.value)}
          >
            <option value="">서비스 목록</option>
            <option value="도어락 관련 서비스">도어락 관련 서비스</option>
            <option value="열쇠 관련 서비스">열쇠 관련 서비스</option>
          </select>
        </div>
        <div className="col-span-2 lg:col-span-2 relative w-full h-full">
          <label htmlFor="address" className="lg:text-xl">
            주소&nbsp;<span className="text-[var(--red-color)]">*</span>
          </label>
          <input
            type="text"
            placeholder="주소를 입력해주세요"
            id="address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>
        <div className=" relative w-full h-full"></div>
        <div className="col-span-2 lg:col-span-3 relative w-full h-full">
          <label htmlFor="contents" className="lg:text-xl">
            문의 내용
          </label>
          <div className=" grid lg:grid-cols-9 gap-5">
            <textarea
              className="lg:col-span-8"
              placeholder="내용을 입력해주세요"
              value={contents}
              name="contents"
              id="contents"
              onChange={(e) => setContents(e.target.value)}
            ></textarea>
            <button
              type="button"
              onClick={handlerPostContact}
              disabled={loading}
              // onClick={() => window.alert("준비중입니다.")}
              className="relative w-full lg:w-fit h-fit mx-auto lg:mx-0 pt-1 px-5 bg-point border border-black rounded-xl"
            >
              <h4 className="font-light text-shadow">전송</h4>
            </button>
          </div>

          {/* <div className="relative w-full h-fit flex justify-between items-center">
            <p className="text-xs sm:text-base leading-tight">
              문자&nbsp;접수&nbsp;후&nbsp;
              <span className="text-[var(--red-color)]">20분&nbsp;이내에</span>
              <br />
              직접&nbsp;전화드릴&nbsp;예정입니다.
            </p>
            </div>
            */}
        </div>
      </div>
    </div>
  );
};

export default Inquiry;
